import React from 'react';
import './SmileyReport.less';
import SmileyReportImage from 'new-images/smiley-report.gif';

export const SmileyReport = ({link}) => {
	return (
		<a className="smiley-report" href={link} target="_blank">
			<img src={SmileyReportImage} alt="Smiley report"/>
		</a>
	)
}
